/**
* Hreflang helpers for the /translation/* cluster. Thai canonical is
* x-default; the 6 shipped locale mirrors are advertised reciprocally so
* Google consolidates ranking signals across the cluster.
*/
import { MLT_COMPARE_SLUG_MAP } from "./compare-locale";
const BASE = "https://thainotarylaw.com";
const LOCALES = ["en", "zh", "ja", "ko", "vi", "id"] as const;

export const TRANSLATION_HREFLANG_LINKS = [
  { rel: "alternate", hrefLang: "th", href: `${BASE}/translation` },
  ...LOCALES.map((l) => ({ rel: "alternate" as const, hrefLang: l, href: `${BASE}/${l}/translation` })),
  { rel: "alternate", hrefLang: "x-default", href: `${BASE}/translation` },
];

/** Reciprocal cluster for the translation FAQ hub. */
export const TRANSLATION_QUESTIONS_HREFLANG_LINKS = [
  { rel: "alternate", hrefLang: "th", href: `${BASE}/translation/questions` },
  ...LOCALES.map((l) => ({
    rel: "alternate" as const,
    hrefLang: l,
    href: `${BASE}/${l}/translation/questions`,
  })),
  { rel: "alternate", hrefLang: "x-default", href: `${BASE}/translation/questions` },
];

/**
* Compare cluster. Only EN and ZH mirrors are published so far, so we
* advertise exactly those (advertising unpublished locales would create
* 404 hreflang targets, which Google Search Console flags).
*/
const COMPARE_LOCALES = ["en", "zh"] as const;

export const TRANSLATION_COMPARE_HUB_HREFLANG_LINKS = [
  { rel: "alternate", hrefLang: "th", href: `${BASE}/translation/compare` },
  ...COMPARE_LOCALES.map((l) => ({
    rel: "alternate" as const,
    hrefLang: l,
    href: `${BASE}/${l}/translation/compare`,
  })),
  { rel: "alternate", hrefLang: "x-default", href: `${BASE}/translation/compare` },
];

/**
* Reciprocal cluster for one compare leaf. Thai slugs may be Thai-script
* while the locale mirrors use ASCII slugs, so pass either and we resolve
* the pair. Returns Thai-only links when the slug has no locale mirror.
*/
export function translationCompareHreflangLinks(slug: string) {
  const map = MLT_COMPARE_SLUG_MAP;
  const thSlug = map[slug] ? slug : (Object.keys(map).find((k) => map[k] === slug) ?? slug);
  const localeSlug = map[thSlug];
  const thHref = `${BASE}/translation/compare/${encodeURI(thSlug)}`;
  if (!localeSlug) {
    return [
      { rel: "alternate", hrefLang: "th", href: thHref },
      { rel: "alternate", hrefLang: "x-default", href: thHref },
    ];
  }
  return [
    { rel: "alternate", hrefLang: "th", href: thHref },
    ...COMPARE_LOCALES.map((l) => ({
      rel: "alternate" as const,
      hrefLang: l,
      href: `${BASE}/${l}/translation/compare/${localeSlug}`,
    })),
    { rel: "alternate", hrefLang: "x-default", href: thHref },
  ];
}
